import {ApiResource} from '../../common/base/api-resource';

export class ConnectionElementEntryResource extends ApiResource {
  idElement: number;
  fiscalYear: number;
  fiscalYearId: number;
}
